import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { phoneCountries } from '../../data/phoneCountries';
type PhoneFieldProps = {
  id: string;
  value: string;
  country: string;
  hasError: boolean;
  required: boolean;
  describedBy?: string;
  onChange: (value: string) => void;
  onCountryChange: (code: string) => void;
  onBlur: () => void;
};
export function PhoneField({
  id,
  value,
  country,
  hasError,
  required,
  describedBy,
  onChange,
  onCountryChange,
  onBlur
}: PhoneFieldProps) {
  const selected = phoneCountries.find(c => c.code === country) ?? phoneCountries[0];
  return <div className={`flex h-12 w-full items-stretch rounded-[10px] border bg-white transition-[border-color,box-shadow] duration-150 ease-out focus-within:border-brand focus-within:ring-2 focus-within:ring-brand/15 ${hasError ? 'border-[#C0362C]' : 'border-ink/15 hover:border-ink/30'}`} data-id="element-522" data-mp="1kcdiga634wwv">
      <div className="relative flex shrink-0 items-center gap-2 border-r border-canvas-line pl-3.5 pr-2.5" data-id="element-523" data-mp="dwjp3u3zr1kt">
        <img src={`https://flagcdn.com/w40/${selected.code.toLowerCase()}.png`} alt="" className="h-3.5 w-5 rounded-[2px] object-cover" data-id="element-524" data-mp="1zf1zuta70l1a" />
        <span className="text-[15px] font-medium text-ink" data-id="element-525" data-mp="29cq3k8ps12vl">{selected.dial}</span>
        <ChevronDownIcon className="h-4 w-4 text-ink-muted" aria-hidden="true" data-id="element-526" data-mp="24dmwyju5eoli" />
        <select aria-label="Country code" value={selected.code} onChange={e => onCountryChange(e.target.value)} className="absolute inset-0 cursor-pointer opacity-0" data-id="element-527" data-mp="24fpurq1jlm0s">
          {phoneCountries.map(c => <option key={c.code} value={c.code} data-id="element-528" data-mp="2s2fxyupmnmmz">
              {c.name} ({c.dial})
            </option>)}
        </select>
      </div>
      <input id={id} type="tel" inputMode="tel" autoComplete="tel-national" placeholder={selected.code === 'RW' ? '788 123 456' : 'Phone number'} value={value} required={required} aria-required={required} aria-invalid={hasError} aria-describedby={describedBy} onChange={e => onChange(e.target.value)} onBlur={onBlur} className="min-w-0 flex-1 rounded-r-[10px] bg-transparent px-3.5 text-[16px] text-ink outline-none placeholder:text-ink-muted/70" data-id="element-529" data-mp="32156vxzjpwr3" />
    </div>;
}